module.exports = __webpack_public_path__ + "img/koi.25520481.png";